Alpine.data('audioPlayer', audioPlayer);

export default function audioPlayer(trackData) {
	return {
		tracks: JSON.parse(trackData),
		currentTrackIndex: 0,
		player: null,
		playing: false,
		progress: 0,
		showTooltip: false,
		tooltipPosition: 0,
		tooltipText: '--:--',
		howlerLoaded: false,

		get currentTrackData() {
			return this.tracks[this.currentTrackIndex];
		},

		init() {
			// Process track data immediately
			this.tracks = this.tracks.map((track) => ({
				src: `https://s3.amazonaws.com/${track.storage_data.s3_bucket_name}/${track.storage_data.s3_path}`,
				title: track.title,
				original_artist: track.original_artist,
				duration: track.playtime > 0 ? this.formatTime(track.playtime) : '--:--',
			}));

			// Use global Howler that's already loaded via separate script
			try {
				this.howlerLoaded = typeof window.Howl !== 'undefined';

				if (!this.howlerLoaded) {
					console.error('Howler.js not found in global scope');
				}
			} catch (error) {
				console.error('Error initializing audio player:', error);
			}
		},

		formatTime(rawTime) {
			const minutes = Math.floor(rawTime / 60);
			const seconds = Math.floor(rawTime % 60)
				.toString()
				.padStart(2, '0');
			return `${minutes}:${seconds}`;
		},

		loadTrack(index) {
			if (window.audioPlayer) {
				window.audioPlayer.unload();
			}

			this.currentTrackIndex = index;
			this.currentTrack = this.tracks[index];

			// Create a new howler instance using global Howl
			window.audioPlayer = new window.Howl({
				src: [this.currentTrack.src],
				html5: true,
				onplay: () => {
					this.playing = true;
					requestAnimationFrame(this.updateProgressBar.bind(this));

					if (this.tracks[this.currentTrackIndex].duration === '--:--') {
						this.tracks[this.currentTrackIndex].duration = this.formatTime(window.audioPlayer.duration());
					}
				},
				onpause: () => {
					this.playing = false;
				},
				onseek: () => {
					requestAnimationFrame(this.updateProgressBar.bind(this));
				},
				onend: () => {
					this.playing = false;
					this.playNext();
				},
			});
		},

		loadTrackAndPlay(index) {
			this.loadTrack(index);
			if (window.audioPlayer) {
				window.audioPlayer.play();
			}
		},

		playNext() {
			const nextIndex = this.currentTrackIndex + 1;
			if (nextIndex < this.tracks.length) {
				this.loadTrackAndPlay(nextIndex);
			}
		},

		seek(event) {
			if (!window.audioPlayer) {
				return;
			}

			const percent = event.offsetX / event.currentTarget.offsetWidth;
			window.audioPlayer.seek(window.audioPlayer.duration() * percent);
			requestAnimationFrame(this.updateProgressBar.bind(this));
		},

		togglePlay() {
			if (!window.audioPlayer) {
				this.loadTrack(0);
			}

			if (window.audioPlayer.playing()) {
				window.audioPlayer.pause();
			} else {
				window.audioPlayer.play();
			}
		},

		updateProgressBar() {
			if (window.audioPlayer) {
				this.progress = (window.audioPlayer.seek() / window.audioPlayer.duration()) * 100;

				// If we're seeking on a paused player or the song has ended, this is a one and done update. Otherwise, continue making
				// the update call recursively to extend the progress bar as the song plays.
				if (window.audioPlayer.playing()) {
					requestAnimationFrame(this.updateProgressBar.bind(this));
				}
			}
		},

		updateTooltip(event) {
			if (!window.audioPlayer) {
				return;
			}

			const progressBar = event.currentTarget;
			const offsetX = event.clientX - progressBar.getBoundingClientRect().x;

			this.tooltipPosition = offsetX;
			const percent = offsetX / progressBar.offsetWidth;
			this.tooltipText = this.formatTime(window.audioPlayer.duration() * percent);
		},
	};
}
